import { Colors, Spacing, Typography } from 'cio-design-library/design-tokens'
import styled from 'styled-components'
import { Icon20 } from '../Icon'

export const Container = styled.div`
  background-color: ${Colors.White};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px;
  width: 360px;
`

export const ButtonContainer = styled.div`
  gap: ${Spacing['2XS']};
  display: flex;
  align-self: end;
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const CloseIcon = styled(Icon20.Close)`
  color: ${Colors.Neutral50};
  border-radius: 28px;
  width: 28px;
  height: 28px;
  padding: 4px;
  background: ${Colors.Neutral10};
  cursor: pointer;

  &:hover {
    background: ${Colors.Blue10};
    color: ${Colors.Blue50};
  }
`

export const Title = styled.p`
  ${Typography.sizes.Subhead};
  font-weight: ${Typography.weights.demibold};
`

export const Body = styled.p`
  ${Typography.sizes.Body};
  color: ${Colors.Neutral50};
`

export const DateText = styled.span`
  font-weight: ${Typography.weights.demibold};
  margin-left: 4px;
`
